import React from "react";
import { Link } from "react-router-dom";

import amcImage from "../assets/images/amc-maintenance.jpg";


import crownePlaza from "../assets/images/Crowne plaza hotel 7-01.jpeg";
import jvcAutograph from "../assets/images/Jvc autograph 3-01.jpeg";
import oldTiblisi from "../assets/images/Old tiblisi 03.jpeg";
import padelCourt from "../assets/images/pc6.jfif";
import qGarden from "../assets/images/Q garden 04.jpeg";
import transmed from "../assets/images/Transmed 03-01.jpeg";


const amcClients = [
  {
    id: 1,
    name: "Crowne Plaza Hotel",
    image: crownePlaza,
    location: "Dubai, UAE",
  },
  {
    id: 2,
    name: "JVC - Autograph",
    image: jvcAutograph,
    location: "Dubai, UAE",
  },
  {
    id: 3,
    name: "Old Tbilisi",
    image: oldTiblisi,
    location: "Dubai, UAE",
  },
  {
    id: 4,
    name: "Padel Court Dubai",
    image: padelCourt,
    location: "Dubai, UAE",
  },
  {
    id: 5,
    name: "Q Garden",
    image: qGarden,
    location: "Dubai, UAE",
  },
  {
    id: 6,
    name: "Transmed",
    image: transmed,
    location: "Dubai, UAE",
  },
];


const AMCMaintenance = () => {

  return (
    <>

      <section
        className="service-page-hero"
        style={{
          backgroundImage: `url(${amcImage})`
        }}
      >
        <div className="service-page-overlay">

          <div className="container text-center">

            <h1>
              Annual Garden Maintenance Contract in Dubai
            </h1>

            <p>
              Reliable year-round garden maintenance and landscaping care.
            </p>

          </div>

        </div>
      </section>


      <section className="service-page-content">

        <div className="container">

          <div className="service-page-intro">

            <span>ANNUAL MAINTENANCE CONTRACT</span>

            <h2>
              Complete Garden Maintenance Throughout the Year
            </h2>

            <p>
              Our Annual Maintenance Contract provides professional,
              scheduled garden care to keep your outdoor spaces healthy,
              clean, attractive, and well maintained throughout the year.
            </p>

          </div>


          <div className="row">

            <div className="col-lg-4 col-md-6">

              <div className="amc-card">

                <i className="fas fa-seedling"></i>

                <h3>
                  Garden Maintenance
                </h3>

                <p>
                  Regular care and maintenance to keep your garden
                  looking fresh and healthy.
                </p>

              </div>

            </div>


            <div className="col-lg-4 col-md-6">

              <div className="amc-card">

                <i className="fas fa-tint"></i>

                <h3>
                  Irrigation Maintenance
                </h3>

                <p>
                  Professional irrigation inspection and maintenance
                  for efficient watering.
                </p>

              </div>

            </div>


            <div className="col-lg-4 col-md-6">

              <div className="amc-card">

                <i className="fas fa-leaf"></i>

                <h3>
                  Plant & Lawn Care
                </h3>

                <p>
                  Regular plant, lawn, pruning, trimming, and
                  general landscape care.
                </p>

              </div>

            </div>

          </div>


          <div className="amc-cta">

            <h2>
              Keep Your Garden Beautiful All Year Round
            </h2>

            <Link
              to="/contact"
              className="amc-btn"
            >
              REQUEST AMC QUOTE
            </Link>

          </div>

        </div>

      </section>

<section className="amc-projects">

  <div className="container">

    <div className="amc-project-heading text-center">

      <span>OUR AMC PROJECTS</span>

      <h2>
        Gardens We Maintain
      </h2>

      <p>
        We provide reliable annual garden maintenance and landscaping
        services for residential, commercial, hospitality, and recreational
        spaces across Dubai.
      </p>

    </div>


  <div className="row">

  {amcClients.map((client) => (
    <div
      className="col-lg-4 col-md-6 col-12"
      key={client.id}
    >

      <div className="amc-project-card">

        <div className="amc-project-image">

          <img
            src={client.image}
            alt={client.name}
          />

        </div>

        <div className="amc-project-info">

          <h3>{client.name}</h3>

          <p>
            <i className="fas fa-map-marker-alt"></i>
            {" "}
            {client.location}
          </p>

          <span className="amc-project-tag">
            Annual Maintenance Contract
          </span>

        </div>

      </div>

    </div>
  ))}

</div>


  </div>


  <style>
    {`

    .amc-projects {
      padding: 90px 20px;
      background: #f8faf7;
    }

    .amc-project-heading {
      max-width: 800px;
      margin: 0 auto 50px;
    }

    .amc-project-heading span {
      color: #4c8b3c;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 3px;
    }

    .amc-project-heading h2 {
      margin: 12px 0 15px;
      font-size: 40px;
      font-weight: 700;
    }

    .amc-project-heading p {
      color: #666;
      line-height: 1.8;
    }


    .amc-project-card {
      height: 100%;
      margin-bottom: 30px;
      overflow: hidden;
      background: #fff;
      border-radius: 12px;

      box-shadow:
        0 8px 30px rgba(0,0,0,.07);

      transition: .35s;
    }

    .amc-project-card:hover {
      transform: translateY(-8px);

      box-shadow:
        0 18px 40px rgba(0,0,0,.13);
    }


    .amc-project-image {
      width: 100%;
      height: 260px;
      overflow: hidden;
      background: #edf3eb;
    }

    .amc-project-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;

      transition: transform .5s ease;
    }

    .amc-project-card:hover
    .amc-project-image img {
      transform: scale(1.07);
    }


    .amc-placeholder {
      width: 100%;
      height: 100%;

      display: flex;
      flex-direction: column;

      align-items: center;
      justify-content: center;

      color: #4c8b3c;
    }

    .amc-placeholder i {
      font-size: 45px;
      margin-bottom: 10px;
    }

    .amc-placeholder span {
      font-size: 13px;
      color: #777;
    }


    .amc-project-info {
      padding: 23px;
    }

    .amc-project-info h3 {
      margin: 0 0 8px;

      color: #222;

      font-size: 20px;
      font-weight: 700;
    }

    .amc-project-info p {
      margin: 0 0 15px;

      color: #777;

      font-size: 14px;
    }

    .amc-project-info p i {
      color: #4c8b3c;
    }


    .amc-project-tag {
      display: inline-block;

      padding: 7px 12px;

      color: #4c8b3c;

      background: #edf6ea;

      border-radius: 20px;

      font-size: 11px;

      font-weight: 700;
    }


    @media(max-width:767px) {

      .amc-projects {
        padding: 60px 15px;
      }

      .amc-project-heading h2 {
        font-size: 30px;
      }

      .amc-project-image {
        height: 240px;
      }

    }

    `}
  </style>

</section>

      <style>
        {`

        .service-page-hero {
          min-height: 520px;

          background-size: cover;
          background-position: center;

          display: flex;
          align-items: center;
        }

        .service-page-overlay {
          width: 100%;

          padding: 100px 20px;

          background: rgba(0,0,0,.5);
        }

        .service-page-hero h1 {
          color: #fff;

          font-size: 50px;

          font-weight: 700;

          max-width: 900px;

          margin: auto auto 15px;
        }

        .service-page-hero p {
          color: #fff;

          font-size: 18px;
        }


        .service-page-content {
          padding: 90px 20px;
        }

        .service-page-intro {
          max-width: 850px;

          margin: 0 auto 60px;

          text-align: center;
        }

        .service-page-intro span {
          color: #4c8b3c;

          font-size: 13px;

          font-weight: 700;

          letter-spacing: 3px;
        }

        .service-page-intro h2 {
          margin: 12px 0 18px;

          font-size: 40px;

          font-weight: 700;
        }

        .service-page-intro p {
          color: #666;

          line-height: 1.8;
        }


        .amc-card {
          height: 100%;

          margin-bottom: 30px;

          padding: 35px 25px;

          text-align: center;

          background: #f7faf6;

          border-radius: 10px;

          transition: .3s;
        }

        .amc-card:hover {
          transform: translateY(-7px);

          box-shadow:
            0 12px 30px rgba(0,0,0,.1);
        }

        .amc-card i {
          color: #4c8b3c;

          font-size: 35px;

          margin-bottom: 20px;
        }

        .amc-card h3 {
          font-size: 21px;
        }

        .amc-card p {
          color: #666;

          line-height: 1.7;
        }


        .amc-cta {
          margin-top: 40px;

          padding: 55px 20px;

          text-align: center;

          background: #4c8b3c;

          border-radius: 12px;
        }

        .amc-cta h2 {
          color: #fff;

          margin-bottom: 20px;
        }

        .amc-btn {
          display: inline-block;

          padding: 13px 25px;

          color: #4c8b3c;

          background: #fff;

          border-radius: 4px;

          font-weight: 700;

          text-decoration: none;
        }


        @media(max-width:767px) {

          .service-page-hero {
            min-height: 420px;
          }

          .service-page-hero h1 {
            font-size: 32px;
          }

          .service-page-intro h2 {
            font-size: 30px;
          }

        }

        `}
      </style>

    </>
  );
};

export default AMCMaintenance;
